export default __webpack_public_path__ + "static/media/Cardiac-chair-on.76027c4b.svg";